import {
  ActivityKindEnum,
  AdFieldCurrencyEnum,
  AdFieldMultilistingEnum,
  CompletionStatusEnum,
} from '@/types';
import type { ClientRequestModel } from '@/types';
import type { NormalizedStorefrontClientRequestRouteState } from './storefrontClientRequestState';

export type ClientRequestFormDefaultValues = Partial<ClientRequestModel>;

export const buildClientRequestFormDefaultValues = (
  routeState: NormalizedStorefrontClientRequestRouteState | null
): ClientRequestFormDefaultValues => {
  const prefill = routeState?.prefill;
  const typeOfActivity = prefill?.typeOfActivity ?? ActivityKindEnum.Sale;
  const isRent = typeOfActivity === ActivityKindEnum.Rent;

  return {
    typeOfActivity,
    completionStatus: isRent ? undefined : prefill?.completionStatus ?? CompletionStatusEnum.All,
    currency: AdFieldCurrencyEnum.AED,
    multilisting: AdFieldMultilistingEnum.Covered,
    title: routeState?.title ?? '',
    ...(isRent && prefill?.period !== undefined ? { period: prefill.period } : {}),
    ...(prefill?.propertyKind !== undefined ? { propertyKind: prefill.propertyKind } : {}),
    ...(prefill?.bedsArr != null ? { bedsArr: [...prefill.bedsArr] } : {}),
    ...(prefill?.baths !== undefined ? { baths: prefill.baths } : {}),
    ...(prefill?.priceFrom !== undefined ? { priceFrom: prefill.priceFrom } : {}),
    ...(prefill?.priceTo !== undefined ? { priceTo: prefill.priceTo } : {}),
    ...(prefill?.areaFrom !== undefined && prefill.areaFrom !== null
      ? { areaFrom: prefill.areaFrom }
      : {}),
    ...(prefill?.areaTo !== undefined && prefill.areaTo !== null ? { areaTo: prefill.areaTo } : {}),
    ...(prefill?.addressEn ? { addressEn: prefill.addressEn } : {}),
    ...(prefill?.nameEn ? { nameEn: prefill.nameEn } : {}),
    ...(prefill?.placeId ? { placeId: prefill.placeId } : {}),
    ...(prefill?.locationId ? { locationId: prefill.locationId } : {}),
    ...(prefill?.coordinatesLat ? { coordinatesLat: prefill.coordinatesLat } : {}),
    ...(prefill?.coordinatesLong ? { coordinatesLong: prefill.coordinatesLong } : {}),
  };
};
